import React from 'react';

import PageLayout from '../../components/blocks/page-layout';
import { useTranslate } from '../../hooks/useTranslate';
import { useLocale } from '../../hooks/useLocale';
import { CookiePolicyNl } from '../../policies/cookie-nl';
import { CookiePolicyFr } from '../../policies/cookie-fr';

export default function Page() {
  const translate = useTranslate();
  const locale = useLocale();

  return (
    <PageLayout title={translate('policies.cookiePolicy')}>
      {locale === 'fr' ? <CookiePolicyFr /> : <CookiePolicyNl />}
    </PageLayout>
  );
}
